module.exports = __webpack_public_path__ + "static/img/ale_apothecary_join_us.606a72a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ale_apothecary_join_us.jpg
// module id = 64
// module chunks = 1